import { IDeleteDeductionBackupDocumentParams, IDeleteDeductionBackupDocumentRepositoryResponse, IRemittanceRepository } from "@/core/repositories/remittance";

export class DeleteDeductionBackupDocumentUseCase {
  constructor(private readonly remittanceRepository: IRemittanceRepository) {}

  async execute(params: IDeleteDeductionBackupDocumentParams): Promise<IDeleteDeductionBackupDocumentRepositoryResponse> {
    return this.remittanceRepository.deleteDeductionBackupDocument(params);
  }
}